<template>
	<div>
		<modaldetail :dialog="dialogDetail" @hideDialog="() => { dialogDetail = false }"></modaldetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Outstanding</div>
		</div>
		<div v-if="loading">
			<loading-card-supplier></loading-card-supplier>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="grey lighten-3" dark class="pa-3">
					<v-list-item dense class="px-1">
						<v-spacer></v-spacer>
						<v-btn text depressed class="cyan darken-2 mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="cyan darken-2" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col class="px-3">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pemesanan" v-model="po_code.value" color="cyan darken-2"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="warehouse.value" :items="optionWarehouse" label="Warehouse Tujuan" color="cyan darken-2" item-color="cyan darken-2" no-data-text="Tidak ada data yang sesuai">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="dateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(search_date)" label="Tanggal Pemesanan" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="cyan darken-2"></v-text-field>
									</template>
									<v-date-picker range color="cyan darken-2" v-model="search_date"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn @click="resetFilter" outlined color="grey darken-1" class="text-capitalize" dark>Reset</v-btn>
								<v-btn @click="cari" depressed color="cyan darken-2" dark class="ml-2 text-capitalize">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
					<v-card-actions class="px-3" v-if="false">
						<v-spacer></v-spacer>
						<v-btn @click="resetFilter" outlined color="grey darken-1" class="text-capitalize" dark>Reset</v-btn>
						<v-btn @click="cari" depressed color="cyan darken-2" dark class="ml-2 text-capitalize">Cari</v-btn>
					</v-card-actions>
				</v-card>
			</v-slide-y-transition>
			<div class="pt-3">
				<v-card outlined v-if="outstandingResults.length == 0 && outstandingPagination">
					<div class="py-3">
						<not-found-cyan></not-found-cyan>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="po in outstandingResults" :key="po.po_id">
					<v-list color="grey lighten-3" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Pemesanan {{ po.po_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn v-if="false" small text depressed class="cyan darken-2" dark @click="printOutstanding(po.po_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm3 md2>
									<div class="body-2 oppacity-75">Warehouse Tujuan</div>
									<div class="subtitle-2">{{ po.warehouse_name }}</div>
									<div class="body-2 pt-3">
										<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ po.warehouse_mobilephone }}</span>
									</div>
								</v-flex>
								<v-flex xs6 sm4 md4 class="pr-3">
									<div class="body-2 oppacity-75">Alamat Warehouse</div>
									<div class="subtitle-2 text-capitalize">{{ addressText(po) }}</div>
								</v-flex>
								<v-flex xs6 sm2 md3>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ po.po_status | toStatusPOWH }}</div>
								</v-flex>
								<v-flex xs6 sm2 md3>
									<div class="body-2 oppacity-75">Tanggal Pemesanan</div>
									<div class="subtitle-2">{{ po.po_status_wh_approved_datetime | tanggal }}</div>
									<div class="pt-3">
										<div class="pr-1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="mr-1" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(po.po_code)">
														<v-icon dark>mdi-text-box-search</v-icon>
													</v-btn>
												</template>
												<span>Detail</span>
											</v-tooltip>
										</div>
									</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
					<div class="pt-1">
						<v-card class="elevation-0">
							<v-data-table dense :headers="headersProduct" :items="po.detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
								<template v-slot:item.draft="{ item }">
									<div>
										{{ item.po_detail_outstanding.draft | toNumber }}
									</div>
								</template>
								<template v-slot:item.on_delivery="{ item }">
									<div>{{ item.po_detail_outstanding.on_delivery | toNumber }}</div>
								</template>
								<template v-slot:item.outstanding="{ item }">
									<div>{{ item.po_detail_outstanding.outstanding | toNumber }}</div>
								</template>
							</v-data-table>
						</v-card>
					</div>
				</v-card>
			</div>
			<div class="pt-5" v-if="outstandingPagination.total_page > 1 && outstandingResults.length > 0">
				<v-row>
					<v-col cols="10" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="outstandingPagination.total_page" total-visible="7" circle class="d-flex justify-end" color="cyan darken-2"></v-pagination>
					</v-col>
					<v-col cols="2" md="1" class="py-0 pl-0">
						<v-autocomplete @change="changeLimit" :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="cyan darken-2" item-color="cyan darken-4"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState} from 'vuex'
import modaldetail from './DetailOutstanding'
import modalPrint from './PrintOutstanding'

export default {
	components: {
		modaldetail, modalPrint
	},
	data() {
		return {
			dropfilter: false,
			dialogDetail: false,
			dialogPrint: false,
			loading: true,
			page: 1,
			listLimit: [ 5, 10, 20, 50, 100 ],
			limit: 10,
			params: [],
			sortBy: 'po_id',
			sortDir: 'DESC',
			headersProduct: [
			{ text: 'Nama Produk', value: 'po_detail_supplier_product_name', sortable: false },
			{ text: 'Outstanding', value: 'outstanding', align: 'center', sortable: false },
			{ text: 'Sedang Dikirim', value: 'on_delivery', align: 'center', sortable: false },
			{ text: 'Belum Dikirim', value: 'draft', align: 'center', sortable: false },
			],
			dateCreate: false,
			dateSent: false,
			po_code: {
				value:'',
				comparison:'=',
				type:'string',
				field: 'po_code'
			},
			warehouse: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'warehouse_id'
			},
			outstanding_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'po_status_wh_approved_datetime'
			},
			search_date: [],
			po_id: '',
		}
	},
	computed: {
		...mapState('poOutstanding', ['outstandingResults', 'outstandingPagination', 'optionWarehouse']),
	},
	methods: {
		...mapActions('poOutstanding', ['getOutStanding', 'getDetailOutstanding', 'exportOutStanging', 'getOptionWarehouse']),

		getData() {
			this.getOutStanding().then(() => {
				this.getOptionWarehouse().then(() => {
					this.loading = false
				})
			})
		},
		exportData(){
			this.exportOutStanging(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getOutStanding(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		changeLimit(limit) {
			this.page = 1
			this.limit = limit
			this.getOutStanding(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		resetFilter() {
			this.search_date = []
			this.po_code.value = ''
			this.outstanding_date.value = ''
			this.warehouse.value = ''
			this.page = 1
			this.getOutStanding(this.queryString({limit:this.limit, page: this.page}))
		},
		cari() {
			this.params = []
			if (this.po_code.value)
				this.params.push(this.po_code)
			if (this.warehouse.value)
				this.params.push(this.warehouse)
			if (this.outstanding_date.value){
				if (this.outstanding_date.value.length > 1) {
					this.outstanding_date.value.sort()
					let date = this.outstanding_date.value.join('::')
					this.outstanding_date.value = date
				}
				this.params.push(this.outstanding_date)
			}
			this.page = 1
			this.getOutStanding(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		addressText(value) {
			var data = []
			if (value.warehouse_address)
				data.push(value.warehouse_address)
			if (value.warehouse_subdistrict_name)
				data.push(value.warehouse_subdistrict_name)
			if (value.warehouse_city_name)
				data.push(value.warehouse_city_name)
			if (value.warehouse_province_name)
				data.push(value.warehouse_province_name)
			return data.join(', ')
		},
		getDetail(code){
			this.getDetailOutstanding(code).then(()=> {
				this.dialogDetail = true
			})
		},
		printOutstanding(code) {
			this.getDetailOutstanding(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Jadwal Pengiriman`);
		this.getData()
	},
	watch: {
		search_date(val) {
			this.outstanding_date.value = val
		},
	}
};
</script>